export const EXPERTS = [
  {
    id: 1,
    firstName: 'Василь Романович',
    lastName: 'Горошко',
    src: 'expert_avatar_1.jpg',
    desc: 'Лікар-анестезіолог. 17 років лікарського стажу. Керівник відділення реанімації та інтенсивної терапії для медичної евакуації та лікування болю Національного військово-медичного клінічного центру «Головний військовий клінічний госпіталь», викладач кафедри хірургії, анестезіології та інтенсивної терапії післядипломної освіти Національного медичного університету імені О.О.Богомольця, доктор медичних наук, Лауреат Національної премії імені Бориса Патона, лікар вищої категорії, полковник медичної служби.'
  },
  {
    id: 2,
    firstName: 'Андрій Дмитрович',
    lastName: 'Кузнецов',
    src: 'expert_avatar_2.jpg',
    desc: 'Лікар-анестезіолог. 13 років лікарського стажу. Старший ординатор відділення реанімації та інтенсивної терапії для медичної евакуації та лікування болю Національного військово-медичного клінічного центру «Головний військовий клінічний госпіталь», лікар вищої категорії, підполковник медичної служби.'
  },
  {
    id: 3,
    firstName: 'Аліна Тарасівна',
    lastName: 'Слободянюк',
    src: 'expert_avatar_3.jpg',
    desc: 'Лікар-анестезіолог. 10 років лікарського стажу. Ординатор відділення реанімації та інтенсивної терапії для медичної евакуації та лікування болю Національного військово-медичного клінічного центру «Головний військовий клінічний госпіталь», лікар вищої категорії, підполковник медичної служби.'
  }
]

export const WORKERS = [
  {
    id: 1,
    name: 'Чернишов Валентин',
    position: '<p>Автор ідеї. Керівник проєкту, лікар-анестезіолог</p><p>к.м.н. MBA, підполковник медичної служби</p>',
    src: 'project_worker_1.jpg'
  },
  {
    id: 2,
    name: 'Гордієнко Віталій',
    position: '<p>Член правління ГО “ФРАТЕР”</p><p>Військовий лікар</p>',
    src: 'project_worker_2.jpg'
  },
  {
    id: 3,
    name: 'Дащенко Олексій',
    position: '<p>IT-підтримка</p><p>Креатив</p>',
    src: 'project_worker_3.jpg'
  }
]

export const ABOUT_CONTENT = [
  {
    id: 1,
    title: 'Біль',
    content: '<p><span class="font-weight-600">Біль</span> – це неприємний чутливий та емоційний досвід, пов’язаний із фактичним чи потенційним пошкодженням тканин або схожий на такий.</p><br/><p>Часто біль служить попередженням про захворювання або травму. У цих випадках лікування основного захворювання є вирішальним і може усунути біль.</p><br/><p>Біль може зберігатися, незважаючи на успішне лікування стану, який його спочатку спричинив, або через те, що основне захворювання не піддається успішному лікуванню.</p>'
  },
  {
    id: 2,
    title: 'Хронічний біль',
    content: '<p><span class="font-weight-600">Хронічний біль</span> – це біль, який зберігається або повторюється більше 3-х місяців.</p><br/><p>Хронічний біль є розповсюдженим станом і вражає приблизно 20% людей у ​​всьому світі.</p><p>Він багатофакторний: біологічні, психологічні та соціальні фактори сприяють виникненню больового синдрому.</p><br/><a href="https://www.iasp-pain.org/advocacy/definitions-of-chronic-pain-syndromes" target="_blank" class="d-block underlined-link">https://www.iasp-pain.org/advocacy/definitions-of-chronic-pain-syndromes</a>'
  },
  {
    id: 3,
    title: 'Нейропатичний біль',
    content: '<p><span class="font-weight-600">Хронічний нейропатичний біль</span> - це хронічний біль, спричинений ураженням або захворюванням нервової системи.</p><br/><p>Біль може бути спонтанним (безперервним або епізодичним) або викликаним, як посилена відповідь на больовий подразник (гіпералгезія) або больова відповідь на зазвичай неболючий подразник (аллодінія).</p><br/><p>Нейропатичний біль є основним джерелом фізичних порушень, емоційних та психо-соціальних розладів і потребує лікування за допомогою специфічних ліків.</p><br/><a href="https://www.iasp-pain.org/advocacy/definitions-of-chronic-pain-syndromes" target="_blank" class="d-block underlined-link">https://www.iasp-pain.org/advocacy/definitions-of-chronic-pain-syndromes</a>'
  },
  {
    id: 4,
    title: 'Які особливості хронічного болю у ветеранів?',
    content: '<p>Хронічний біль після мінно-вибухових поранень діагностується в 83% випадків, а після вогнепальних - в 70%. Для порівняння: в «цивільному» житті  хронізація болю після травм відмічається у 11-40% постраждалих.</p><br/><p>В середньому, ветеран з вогнепальним пораненням має на 45% більший ризик отримати хронічний біль, ніж цивільний пацієнт з небойовою травмою. Причиною цього є гострі стресові реакції та нейропатичний компонент болю.</p><br/><p>Відчуття   і   емоції,  що  пережили  пацієнти  під  час  поранення в  умовах  бойових  дій,  мають  свої  особливості. Такі  пацієнти  потребують  спеціального підходу до лікування болю.</p><br/><a href="https://doi.org/10.32345/2664-4738.1.2023.01" target="_blank" class="d-block underlined-link">https://doi.org/10.32345/2664-4738.1.2023.01</a><a href="https://doi.org/10.1186/s12871-023-02005-3" target="_blank" class="d-block underlined-link">https://doi.org/10.1186/s12871-023-02005-3</a><a href="https://doi.org/10.1186/s12871-023-02005-3" target="_blank" class="d-block underlined-link">https://doi.org/10.1186/s12871-023-02005-3</a>'
  },
  {
    id: 5,
    title: 'Чому біль необхідно лікувати?',
    content: '<p>Якщо хронічний біль не лікувати, то це в майбутньому знизить якість життя, погіршить загальний стан здоров’я та соціальну адаптацію пацієнта.</p><br/><p>Хронічний біль підвищує загальну смертність, збільшує ризик розвитку ожиріння, депресії, суїциду, наркоманії. Так, спроби самогубств спостерігаються у 5%-14% пацієнтів з хронічним болем, а думки про самогубство з’являються в середньому у кожного 5-го.</p><br/><p>А ще хронічний біль пов’язаний з вищим рівнем безробіття та нижчим рівнем оплати праці.</p><br/><p>Щодо лікування, то зменшення інтенсивності болю навіть на 30% значно покращує фізичну активність пацієнтів та їхній рівень життя.</p><br/><p>Дуже важливим є недопущення хронізації болю через адекватне лікування гострого та підгострого болю. Доведено, що це зменшує зниження якості життя в майбутньому.</p><br/><a href="https://doi.org/10.1016/s0304-3959(01)00349-9" target="_blank" class="d-block underlined-link">https://doi.org/10.1016/s0304-3959(01)00349-9</a><a href="https://www.ncbi.nlm.nih.gov/books/NBK553030" target="_blank" class="d-block underlined-link">https://www.ncbi.nlm.nih.gov/books/NBK553030</a>'
  },
  {
    id: 6,
    title: 'Чим можна оцінити біль?',
    content: '<p>Інтенсивність болю найчастіше оцінюють за шкалами болю. До таких відносять числову, візуально-аналогову та інші.</p><br/><p>На числовій шкалі пацієнт повідомляє усно або відмічає письмово рівень болю, який відчуває в балах від 0 (біль відсутній) до 10 (найгірший біль, який тільки можна уявити).</p><br/><a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3454549" target="_blank" class="d-block underlined-link">https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3454549</a><br /><p>Нейропатичний компонент болю діагностують та оцінюють за шкалою DN4 (Douleur Neuropathique 4 questions).</p><br /><a href="https://aci.health.nsw.gov.au/__data/assets/pdf_file/0014/212900/DN4_Assessment_Tool.pdf" target="_blank" class="d-block underlined-link">https://aci.health.nsw.gov.au/__data/assets/pdf_file/0014/212900/DN4_Assessment_Tool.pdf</a><br/><p>Для оцінки якості життя використовують шкалу Chaban Quality of Life Scale (CQLS).</p><br /><a href="https://www.ecnp.eu/presentationpdfs/70/P.2.h.301.pdf" target="_blank" class="d-block underlined-link">https://www.ecnp.eu/presentationpdfs/70/P.2.h.301.pdf</a>'
  },
  {
    id: 7,
    title: 'Як лікують хронічний біль?',
    content: '<p>Хронічний біль найефективніше лікується (контролюється) спільними зусиллями пацієнта, членів його родини та команди професіоналів з охорони здоров’я, серед яких варто виділити сімейного лікаря та спеціаліста з лікування болю (альголога).</p><br/><p>Сучасне лікування болю засноване на мультимодальному підході, що означає одночасне застосування, як медикаментозного лікування, так і немедекаментозних методів.</p><br/><p>Серед медикаментів найчастіше використовуються ненаркотичні (парацетамол, нестероїдні протизапальні засоби, нефопам та ін.) та наркотичні (морфін, фентаніл, гідроморфон та ін.) анальгетики.</p><br/><p>Якщо присутній нейропатичний компонент, до лікування додають прегабалін або габапентин.</p><br/><p>Вогнепальні та мінно-вибухові поранення майже завжди супроводжуються проявами нейропатичного болю, через що прегабалін або габапентин рекомендується застосовувати за будь-якої інтенсивності в першій лінії лікування.</p><br/><p>Місцево можуть бути призначені засоби з лідокаїном, капсаїцином.</p><br/><p>Для лікування супутньої депресії застосовуються антидепресанти - трициклічні або інгібітори зворотнього захоплення серотоніну.</p><br/><p>Для лікування болю середньої та високої інтенсивності після вогнепальних та мінно-вибухових поранень додатково застосовується регіонарна анестезія місцевими анестетиками.</p><br/><p>Широкий перелік немедикаментозних та інвазивних методів також може бути використаний при лікуванні хронічного болю.</p><br/><a href="https://www.ncbi.nlm.nih.gov/books/NBK553030" target="_blank" class="d-block underlined-link">https://www.ncbi.nlm.nih.gov/books/NBK553030</a><a href="https://www.ncbi.nlm.nih.gov/books/NBK553030" target="_blank" class="d-block underlined-link">Новий клінічний протокол. Знеболення пацієнтів з вогнепальними та мінно-вибуховими пораненнями на етапах лікування у закладах охорони здоров’я в системі Міністерства оборони України. 2022. 27 с.</a>'
  }
]

export const SOCIALS = [
  {
    id: 1,
    src: 'facebook_icon.svg',
    link: 'https://www.facebook.com/stoppainua/',
    share: 'https://www.facebook.com/sharer/sharer.php?u='
  },
  {
    id: 2,
    src: 'twitter_icon.svg',
    share: 'http://twitter.com/share?url='
  },
  {
    id: 3,
    src: 'instagram_icon.svg',
    share: 'https://www.instagram.com/'
  },
  {
    id: 4,
    src: 'telegram_icon.svg',
    link: 'https://t.me/stoppainuabot',
    share: 'https://telegram.me/share/url?url='
  },
  {
    id: 5,
    src: 'whats_app_icon.svg',
    share: 'whatsapp://send?text=',
  },
  {
    id: 6,
    src: 'linked_in_icon.svg',
    link: 'https://www.linkedin.com/company/stoppainua/',
    share: 'https://www.linkedin.com/shareArticle?mini=true&url='
  }
]

export const POSTERS = [
  {
    id: 1,
    src: 'poster_preview_1.jpg',
    link: '/Stop Pain UA Poster 1.tif'
  },
  {
    id: 2,
    src: 'poster_preview_2.jpg',
    link: '/Stop Pain UA Poster 2.tif'
  },
  {
    id: 3,
    src: 'poster_preview_3.jpg',
    link: '/Stop Pain UA Poster 3.tif'
  },
  {
    id: 4,
    src: 'poster_preview_4.jpg',
    link: '/Stop Pain UA Poster 4.tif'
  },
  {
    id: 5,
    src: 'poster_preview_5.jpg',
    link: '/Stop Pain UA Poster 5.tif'
  },
  {
    id: 6,
    src: 'poster_preview_6.jpg',
    link: '/Stop Pain UA Poster 6.tif'
  },
  {
    id: 7,
    src: 'poster_preview_7.jpg',
    link: '/Stop Pain UA Poster 7.tif'
  },
  {
    id: 8,
    src: 'poster_preview_8.jpg',
    link: '/Stop Pain UA Poster 8.tif'
  },
  {
    id: 9,
    src: 'poster_preview_9.jpg',
    link: '/Stop Pain UA Poster 9.tif'
  }
]

export const SHARE_DATA = {
  title: '#БезБолюUA',
  text: 'Ти - ветеран і маєш постійний біль? Разом з #БезБолюUA отримай швидку безкоштовну допомогу кращих фахівців.'
}

export const PARTNERS = [
  {
    id: 1,
    src: 'frater_main_logo_gold.svg',
    link: 'https://frater.ngo'
  },
  {
    id: 2,
    src: 'partner_1.jpg',
    link: 'https://www.facebook.com/GVKG.KYIV/'
  },
  {
    id: 3,
    src: 'partner_2.png',
    link: 'https://dermguard.org'
  },
  {
    id: 4,
    src: 'partner_3.jpg',
    link: ''
  }
]

export const LIBRARY_LINKS = [
  {
    id: 1,
    value: 'https://drive.google.com/file/d/1IjRQvk1H6C7YMIJ_lefwwMkeZcKfdYVO/view?usp=sharing',
    name: 'Клінічний протокол знеболення пацієнтів з вогнепальними та мінно-вибуховими пораненнями на етапах лікування у закладах охорони здоров\'я в системі Міністерства Оборони України, 2022 рік'
  }
]

export const REHABILITATION_LINKS = []
